<template>
  <v-container fluid>
    <a name='about'></a>
    <h2><a href='#about'>About</a></h2>
    <v-container>
      <div class='messsage'>
        日本でマストドンが話題に上がってから1年半が経過しました。<br />
        どの組織にも縛られないこの自由な分散SNSの世界では、マストドンを中心として様々な文化や知識、技術が育まれてきています。<br />
        Mastodon Meetup at Tokyoに参加してその一端に触れてみませんか？<br />
      </div>

      <v-layout class='table' row wrap>
        <v-container v-for='data in table' :key='data.id' class='table_row' fluid>
          <v-layout xs12 sm12 md12 row wrap>
            <v-flex class='table_row_key font_caption' xs12 sm3 md3>
              {{ data.key }}
            </v-flex>
            <v-flex class='table_row_val' v-html='data.val' xs12 sm9 md9>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>

      <div class='caution'>
        <div class='caution_title'>
          参加登録について
        </div>
        <div class='caution_message'>
          当日お越しになる方は、事前に参加登録をお願いいたします。<br />
          受付にて確認させていただきます。<br />
          <br />
          <a href='https://connpass.com/event/102650/' target='_blank' class='secondary--text'>https://connpass.com/event/102650/</a>
        </div>
      </div>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'eventinfo',
  props: {},
  data: () => {
    return {
      table: [
        {
          id: 0,
          key: '日時',
          val: '2018年11月3日 (土) 14:00〜17:00 (30分前から開場)'
        },
        {
          id: 1,
          key: '場所',
          val: '株式会社インターネットイニシアティブ 東京本社 13階<br />当日は、会場ビル(飯田橋グラン・ブルーム)の2Fのオフィスロビーへお越しください。<br /><a href=\'https://mitsui-shopping-park.com/urban/sakuraterrace/floorguide.html\' target=\'_blank\'>フロアガイドを見る</a>'
        },
        {
          id: 2,
          key: '参加費',
          val: '無料 (<a href=\'https://connpass.com/event/102650/\' target=\'_blank\' class=\'secondary--text\'>要事前登録</a>)'
        },
        {
          id: 3,
          key: 'ハッシュタグ',
          val: '#mmt18'
        }
      ]
    };
  }
}
</script>

<style scoped>
  .messsage {
    text-align: center;
  }

  .table {
    margin-top: 3rem;
  }

  .table_row {
    border-bottom: solid 1px rgb(193, 193, 193);
    padding: 1.5rem 3rem;
  }

  .table_row_key {
    font-weight: bold;
    font-size: 1rem;
  }

  .caution {
    margin-top: 3rem;
  }
</style>
